<template>
 <div :class="windowClass">
   
      <v-row dense no-gutters>
         <v-col cols="12">
            <chart-gross :rawdata="sales"/>
         </v-col>
      </v-row>
        <v-container fluid>
        <v-row dense class="mt-3">
            <v-col cols="3"  md="3" class="pa-1">
              <va-stat-card 
                  color="secondary"
                  icon="mdi-cash-register"
                  label="Today's Sales"
                  :data="$count(TODAY_COUNT)"
                  sup="FULLS"
                />
            </v-col>
            <v-col cols="3" class="pa-1">
              <va-stat-card 
                  color="secondary"
                  icon="mdi-calendar"
                  label="month's Sales"
                  :data="$count(MONTHGROSS)"
                  sup="FULLS"
                />
            </v-col>
            <v-col cols="3"  md="3"  class="pa-1">
              <va-stat-card 
                  color="secondary"
                  icon="mdi-receipt"
                  label="month's Invoices"
                  :data="$count(invoice.count)"
                  sup=""
                />
            </v-col>
            <v-col cols="3"  md="3" class="pa-1">
              <va-stat-card 
              color="secondary"
              icon="mdi-bottle-soda-classic-outline"
              label="Products"
              :data="$count(product.count)"
              sup=""
            />
            </v-col>
        </v-row>
        </v-container>
        <v-row dense no-gutters>
          <v-col cols="6" class="pa-1">
            <chart-pie :rawdata="category_sales"/>
          </v-col>
            <v-col cols="6" class="pa-1">
              <v-card flat>
                <v-toolbar dense flat>
                    <v-icon  left color="primary">mdi-bottle-soda-classic-outline</v-icon> Actual Mechandise
                </v-toolbar>
                <v-data-table
                        class="va-table mt-2"
                        dense
                        :headers="[{text:'Category'}, {text:'Available' , value: 'count', align:'right'}]"
                        hide-default-footer
                        :items="stocks"
                        >
                         <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                            <td>{{ item.label}}</td>
                            <td class="text-right">{{ $count(item.count)}}</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
              </v-card>
            </v-col>
        </v-row>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      sales:[],
      invoice:{},
      product:{},
      stocks: [],
      category_sales: []
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
         this.SET_MENUS()
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getmonthlySales()
        }
         var a = this.$moment('2020-12-10')
          var b = this.$moment()
          var left = a.diff(b, 'days')
       if(left != 0) {
          this.VA_ALERT('warning',left + " more days left on your demo! Upgrade now!")
       } else if(left == 0) {
          this.VA_ALERT('warning', "Demo account hass been expired!! Upgrade now!")
          setTimeout(()=>{  this.$router.push('/')}, 4000)
       }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      MONTHGROSS() {
          var total = this.sales.reduce((res,item)=>res+=this.$IsNum(item.quantity), 0)
          return total
      },
      TODAY_COUNT() {
          if(this.sales.length == 0) {
            return 0
          }
          return this.sales[this.sales.length - 1].quantity
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      getmonthlySales() {
            this.APPLOADER(true,'')
            this.$http.post("report/get_month_sales", {}).then(response => {
                  response.data.sales !=null?this.sales = response.data.sales:this.sales= []
                  response.data.invoice !=null?this.invoice = response.data.invoice:this.invoice= {}
                  response.data.product !=null?this.product = response.data.product:this.product= {}
                  response.data.stocks !=null?this.stocks = response.data.stocks:this.stocks= []
                   response.data.category_sales !=null?this.category_sales = response.data.category_sales:this.category_sales= []
                setTimeout(()=>{this.APPLOADER(false,'')}, 500)
              }).catch(e => {
                console.log(e.data)
            })
        }
    },
  }
</script>